import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatsappImagesRoutingModule } from './whatsapp-images-routing.module';
import { WhatsappImagesComponent } from './whatsapp-images.component';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonImagesComponent } from 'src/app/pages/common-images/common-images.component';
import { CommonImagesModule } from 'src/app/pages/common-images/common-images.module';


@NgModule({
  declarations: [
    WhatsappImagesComponent
  ],
  imports: [
    CommonModule,
    WhatsappImagesRoutingModule,
    SharedModule,
    CommonFileUploadModule,
    CommonImagesModule
    
  ], exports: [
    WhatsappImagesComponent
  ]
})
export class WhatsappImagesModule { }
